import { render, staticRenderFns } from "./BlogPostsList.vue?vue&type=template&id=1453d0aa&"
import script from "./BlogPostsList.vue?vue&type=script&lang=js&"
export * from "./BlogPostsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jlamb/repos/roll20/d20app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1453d0aa')) {
      api.createRecord('1453d0aa', component.options)
    } else {
      api.reload('1453d0aa', component.options)
    }
    module.hot.accept("./BlogPostsList.vue?vue&type=template&id=1453d0aa&", function () {
      api.rerender('1453d0aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/blog-preview/src/components/BlogPostsList.vue"
export default component.exports